<template>
  <div class="articleContent">
    <div>
      <el-card class="office-card" shadow="never">
        <quick-entrys :dataList="textContent"></quick-entrys>
      </el-card>
    </div>
    <div class="title">
      <span class="title-sty">办件公示</span>
    </div>
    <div class="announcement">
      <!-- <div class="tips">（办件公示仅可查询本年度申请事项的办理状态）</div> -->
      <div class="superior">
        <el-form
          ref="form"
          :model="applyForm"
          label-width="80px"
          style="margin-top: 20px"
        >
          <el-form-item label="申请时间">
            <el-date-picker
              popper-class="timeclass"
              v-model="dateStr"
              type="date"
              placeholder="开始时间"
              @change="timeStaChange()"
            >
            </el-date-picker>
            <span style="font-size: 16px; margin-left: 5px; margin-right: 5px"
              >至</span
            >
            <el-date-picker
              popper-class="timeclass"
              v-model="dateEnd"
              type="date"
              placeholder="结束时间"
              @change="timeEndChange()"
            >
            </el-date-picker>

            <!-- <el-date-picker
              v-model="timeData"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              popper-class="dateclass"
              @change="timeDataChange"
            >
            </el-date-picker> -->
          </el-form-item>
        </el-form>
        <div>
          <el-input
            v-model="searchOne"
            maxlength="26rem"
            placeholder="事项类型/申请人/单位/办理状态"
            class="input-with-select"
            style="width: 26rem"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              size="small"
              @click="search()"
            ></el-button>
          </el-input>
          <el-button class="reset" @click="resetOn()">重置</el-button>
        </div>
      </div>
      <div style="padding: 0 20px; text-align: center">
        <el-table
          :data="publicNotice"
          border
          :stripe="true"
          fit
          style="width: 100%"
          :header-cell-style="{
            background: '#ebe6db',
            color: '#585856',
            borderColor: '#585856',
          }"
          :cell-style="{ borderColor: '#585856' }"
        >
          <el-table-column
            align="center"
            type="index"
            :index="count"
            label="序号"
            width="60"
          >
          </el-table-column>
          <el-table-column
            min-width="475px"
            align="center"
            prop="itemSname"
            label="事项类型"
          >
          </el-table-column>
          <el-table-column
            min-width="175px"
            align="center"
            prop="applicantName"
            label="申请人/申请单位"
          >
          </el-table-column>
          <el-table-column
            min-width="175px"
            align="center"
            prop="applyTime"
            label="申请时间"
          >
          </el-table-column>
          <el-table-column
            min-width="100px"
            align="center"
            prop="currentStatus"
            label="办理状态"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          popper-class="pageclass"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 40, 80]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <div class="title">
      <span class="title-sty">办件统计</span>
    </div>
    <div class="announcement">
      <div class="tips">（每月1日发布上一月份行政审批统计数据）</div>
      <div class="superior">
        <el-form
          ref="form"
          :model="applyForm"
          label-width="80px"
          style="margin-top: 20px"
        >
          <el-form-item label="统计时间">
            <el-date-picker
              popper-class="timeclass"
              v-model="dateStatStr"
              type="date"
              placeholder="开始时间"
              @change="timeStatDataChange()"
            >
            </el-date-picker>
            <span style="font-size: 16px; margin-left: 5px; margin-right: 5px"
              >至</span
            >
            <el-date-picker
              popper-class="timeclass"
              v-model="dateStatEnd"
              type="date"
              placeholder="结束时间"
              @change="timeStatDataChange()"
            >
            </el-date-picker>
            <!-- <el-date-picker
              v-model="timeStatData"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              popper-class="dateclass"
              @change="timeStatDataChange"
            >
            </el-date-picker> -->
          </el-form-item>
        </el-form>
        <div>
          <el-button class="reset" @click="resetTw()">重置</el-button>
        </div>
      </div>
      <div style="padding: 0 20px; text-align: center">
        <el-table
          :data="statisticsNotice"
          border
          :stripe="true"
          fit
          style="width: 100%"
          :header-cell-style="{
            background: '#ebe6db',
            color: '#585856',
            borderColor: '#585856',
          }"
          :cell-style="{ borderColor: '#585856' }"
        >
          <el-table-column
            align="center"
            type="index"
            :index="countTwo"
            label="序号"
            width="60"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="statisticalTime"
            label="统计时间"
            min-width="240px"
          >
          </el-table-column>
          <el-table-column align="center" label="统计内容">
            <el-table-column align="center" prop="newApply" label="新申请事项">
            </el-table-column>
            <el-table-column
              align="center"
              prop="promiseApply"
              label="承诺时限内办结事项"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="expectApply"
              label="逾期办理事项"
            >
            </el-table-column>
          </el-table-column>
        </el-table>
        <el-pagination
          popper-class="pageclass"
          @size-change="handleSizeChangeDb"
          @current-change="handleCurrentChangeDb"
          :current-page="currentPageDb"
          :page-sizes="[6, 12, 24]"
          :page-size="pagesizeTwo"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDb"
          style="margin: 10px 0"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { officePublic } from "../../utils/staticDict";
import { URL_PORTAL_APPLYLIST, URL_PORTAL_STATISTIC } from "../../utils/api";
import util from "../../utils/util";
import { frontHeater } from "../../utils/md5encryption";
export default {
  name: "officePublic",
  props: [],
  components: {
    "quick-entrys": () => import("@/components/Home/QuickEntrys.vue"),
  },
  data() {
    return {
      // 文字内容
      textContent: officePublic,
      // 日期属性
      applyForm: {
        // 办件公示时间
        publicityStartStr: "",
        publicityStartEnd: "",
        // 办件统计时间
        statisticsStartStr: null,
        statisticsStartEnd: null,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      // 办件公示搜索
      searchOne: null,
      // 办件公示表格
      publicNotice: [],
      // 办件统计表格
      statisticsNotice: [],
      // 办件公示前往页数
      currentPage: 1,
      // 办件公示总条数
      total: 100,
      pagesize: 10,
      // 办件统计前往页数
      currentPageDb: 1,
      // 办件统计总条数
      totalDb: 100,
      pagesizeTwo: 6,
      timeData: [],
      dateList: [],
      dateStr: "",
      dateEnd: "",
      timeStatData: [],
      dateStatList: [],
      dateStatStr: "",
      dateStatEnd: "",
    };
  },
  computed: {},
  mounted() {
    this.getList();
    this.getTwoList();
  },
  methods: {
    // 办件公示请求列表数据
    getList() {
      let result = frontHeater([""], [""]);
      let Url = util.getAjaxUrl("axiosThree");
      if (this.dateStr == "") {
        var dateStrs = "";
      } else {
        var dateStrs = this._formatDate(this.dateStr);
      }
      if (this.dateEnd == "") {
        var dateEnds = "";
      } else {
        var dateEnds = this._formatDate(this.dateEnd);
      }
      // let list = this.timeData;
      // if (list != undefined) {
      //   list.forEach((item) => {
      //     let date = new Date(item);
      //     let MM = date.getMonth() + 1;
      //     MM = MM < 10 ? "0" + MM : MM;
      //     let d = date.getDate();
      //     d = d < 10 ? "0" + d : d;
      //     let times = date.getFullYear() + "-" + MM + "-" + d;
      //     this.dateList.push(times);
      //   });
      //   if (this.dateList[0]) {
      //     this.dateStr = this.dateList[0];
      //     this.dateEnd = this.dateList[1];
      //     console.log(this.dateStr + this.dateEnd);
      //   }
      // }
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http
        .get(
          Url +
            `${URL_PORTAL_APPLYLIST}?pageSize=${this.pagesize}&pageNumber=${this.currentPage}&timeFrom=${dateStrs}&timeTo=${dateEnds}&conditions=${this.searchOne}`
        )
        .then((res) => {
          if (res.status == 200) {
            this.publicNotice = res.data.data;
            this.total = res.data.recordsTotal;
          }
        });
    },
    formatdates(time) {
      if (time === null) return "";
      let date = new Date(time); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let m = date.getMonth() + 1,
        mm = m < 10 ? "0" + m : m;
      let d = date.getDate(),
        dd = d < 10 ? "0" + d : d;
      return date.getFullYear() + "-" + mm + "-" + dd;
    },
    _formatDate(time) {
      if (time === null) return "";
      let date = new Date(time); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let m = date.getMonth() + 1,
        mm = m < 10 ? "0" + m : m;
      let d = date.getDate(),
        dd = d < 10 ? "0" + d : d;
      let h = date.getHours(),
        hh = h < 10 ? "0" + h : h;
      let i = date.getMinutes(),
        ii = i < 10 ? "0" + i : i;
      let s = date.getSeconds(),
        ss = s < 10 ? "0" + s : s;
      return (
        date.getFullYear() +
        "-" +
        mm +
        "-" +
        dd +
        "  " +
        hh +
        ":" +
        ii +
        ":" +
        ss
      );
    },

    // formatDate(date) {
    //   const time = new Date(date);
    //   return (
    //     time.getFullYear() + "-" + (time.getMonth() + 1) + "-" + time.getDate()
    //   );
    // },
    timeStaChange() {
      this.currentPage = 1;
      this.pagesize = 10;
      this.getList();
    },
    timeEndChange() {
      this.currentPage = 1;
      this.pagesize = 10;
      this.getList();
    },
    //时间
    timeDataChange() {
      this.getList();
      this.dateList = [];
      this.dateStr = "";
      this.dateEnd = "";
    },
    timeStatDataChange() {
      this.getTwoList();
    },
    // 办件统计请求列表数据
    getTwoList() {
      let result = frontHeater([""], [""]);
      let Url = util.getAjaxUrl("axiosThree");
      if (this.dateStatStr !== "") {
        this.dateStatStr = this.formatdates(this.dateStatStr);
      }
      if (this.dateStatEnd == "") {
        var dateStatEnd = "";
      } else {
        var dateStatEnd = this.formatdates(this.dateStatEnd);
      }
      // let list = this.timeStatData;
      // if (list != undefined) {
      //   list.forEach((item) => {
      //     let date = new Date(item);
      //     let MM = date.getMonth() + 1;
      //     MM = MM < 10 ? "0" + MM : MM;
      //     let d = date.getDate();
      //     d = d < 10 ? "0" + d : d;
      //     let times = date.getFullYear() + "-" + MM + "-" + d;
      //     this.dateStatList.push(times);
      //   });
      //   if (this.dateStatList[0]) {
      //     this.dateStatStr = this.dateStatList[0];
      //     this.dateStatEnd = this.dateStatList[1];
      //   }
      // }
      let params = {
        pageSize: this.pagesizeTwo,
        pageNumber: this.currentPageDb,
        timeFrom: this.dateStatStr,
        timeTo: dateStatEnd,
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.post(Url + URL_PORTAL_STATISTIC, params).then((res) => {
        if (res.status == 200) {
          this.statisticsNotice = res.data.data;
          this.totalDb = res.data.recordsTotal;
        }
      });
    },
    // 办件公示重置
    resetOn() {
      this.searchOne = "";
      this.currentPage = 1;
      this.pagesize = 10;
      this.dateStr = "";
      this.dateEnd = "";
      this.timeData = [];
      this.getList();
    },
    publicityStartStrChange() {
      this.getList();
    },
    publicityStartEndChange() {
      this.getList();
    },
    // 办件统计重置
    resetTw() {
      this.currentPageDb = 1;
      this.pagesizeTwo = 6;
      this.dateStatStr = "";
      this.dateStatEnd = "";
      this.timeStatData = [];
      this.getTwoList();
    },
    statisticsStartStrChange() {
      this.getTwoList();
    },
    statisticsStartEndChange() {
      this.getTwoList();
    },
    // 办件公示搜索
    search() {
      this.getList();
    },
    // 办件公示序号index
    count(index) {
      return (this.currentPage - 1) * this.pagesize + index + 1;
    },
    // 办件统计序号index
    countTwo(index) {
      return (this.currentPageDb - 1) * this.pagesizeTwo + index + 1;
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    handleSizeChangeDb(val) {
      this.pagesizeTwo = val;
      this.getTwoList();
    },
    handleCurrentChangeDb(val) {
      this.currentPageDb = val;
      this.getTwoList();
    },
  },
};
</script>
<style scoped lang='less'>
@import "../../styles/base";
@import "../../styles/comSty";
/deep/ .el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 380px;
}
/deep/ .el-date-editor .el-range-input,
.el-date-editor .el-range-separator {
  font-size: 16px !important;
}
/deep/ .el-range-separator {
  font-size: 16px !important;
}
/deep/ .el-button {
  font-size: 16px !important;
}
.tips {
  font-size: 14px;
}
</style>
